var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElectric = function SvgElectric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.147 7.335c0-.752.61-1.362 1.362-1.362h4.981c.752 0 1.362.61 1.362 1.362v1.593c0 2.097-1.699 3.796-3.795 3.796h-.115a3.796 3.796 0 0 1-3.795-3.796V7.335Zm1.362-.583a.584.584 0 0 0-.584.583v1.593a3.017 3.017 0 0 0 3.017 3.018h.115a3.017 3.017 0 0 0 3.017-3.018V7.335a.584.584 0 0 0-.584-.583H7.51Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.026 2.996a.39.39 0 0 1 .389.39V6.23a.39.39 0 1 1-.779 0V3.385a.39.39 0 0 1 .39-.389ZM10 11.946a.39.39 0 0 1 .389.389v4.268a.39.39 0 1 1-.779 0v-4.268a.39.39 0 0 1 .39-.39ZM11.974 2.996a.39.39 0 0 1 .389.39V6.23a.39.39 0 1 1-.779 0V3.385a.39.39 0 0 1 .39-.389Z",
    fill: "currentColor"
  })));
};
export default SvgElectric;